import React, {useState} from 'react';
import {FaEnvelope, FaEye, FaEyeSlash, FaWhatsapp} from 'react-icons/fa';
import {useLang} from '../../context/LanguageContext';
import {useAuth} from '../../context/AuthContext';

const CONTACT_EMAIL = 'xsxa24@gmail.com';
const WHATSAPP_DISPLAY = '0731167894';
const WHATSAPP_INTL = '40731167894';

const CardEmail = () => {
  const {t} = useLang();
  const {currentUser} = useAuth();
  const [showEmail, setShowEmail] = useState(false);

  const handleMailClick = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`;
  };

  const handleWhatsAppClick = () => {
    const message = currentUser ? `Buna ziua, email-ul meu este: ${currentUser.email}` : 'Buna ziua';
    const url = `https://wa.me/${WHATSAPP_INTL}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="max-w-[95vw] md:max-w-[800px] mx-auto my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] p-4 space-y-3">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-shrink-0 text-[#2ecc71] text-2xl">
            <FaEnvelope/>
          </div>
          <div className="flex flex-col text-white min-w-0">
            <span className="text-sm font-extrabold text-[#e67e22]">{t('txt.contactEmail')}</span>
            {showEmail && (
              <span className="text-sm font-semibold break-all">{CONTACT_EMAIL}</span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => setShowEmail((prev) => !prev)}
            className="px-2.5 py-1.5 bg-[#2c3e50] hover:bg-[#22303f] text-white rounded-md flex items-center gap-1.5 text-xs font-semibold"
          >
            {showEmail ? <FaEyeSlash/> : <FaEye/>}
            <span className="hidden sm:inline">{t('txt.showEmail')}</span>
          </button>
          <button
            onClick={handleMailClick}
            className="px-2.5 py-1.5 bg-[#2ecc71] hover:bg-green-600 text-white rounded-md flex items-center gap-1.5 text-xs font-semibold"
          >
            <FaEnvelope/>
            <span className="hidden sm:inline">{t('txt.sendEmail')}</span>
          </button>
        </div>
      </div>

      <button
        onClick={handleWhatsAppClick}
        className="w-full flex items-center justify-between gap-3 pt-3 border-t border-white/20 text-left"
      >
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-shrink-0 text-[#25D366] text-2xl">
            <FaWhatsapp/>
          </div>
          <div className="flex flex-col text-white min-w-0">
            <span className="text-sm font-extrabold text-[#e67e22]">{t('txt.contactWhatsapp')}</span>
            <span className="text-sm font-semibold">{WHATSAPP_DISPLAY}</span>
          </div>
        </div>
      </button>
    </div>
  );
};

export default CardEmail;
